import { Text } from "components";

import classes from "./ProgressSection.module.css";

interface YearlyProgressProps {
  title: string;
  progress: number;
  targetLabel: string;
  realizedLabel: string;
}

const YearlyProgress = ({
  title,
  progress,
  targetLabel,
  realizedLabel,
}: YearlyProgressProps) => {
  const normalizedProgress = Math.min(Math.max(progress, 0), 1);

  return (
    <div className={classes.panel}>
      <Text className={classes.panelTitle}>{title}</Text>

      <div className={classes.yearlyBody}>
        <div className={classes.yearlyArrow} aria-hidden="true">
          <div className={classes.yearlyArrowHead} />
          <div className={classes.yearlyArrowStem} />
        </div>

        <div className={classes.yearlyChart}>
          <Text className={classes.yearlyTarget}>{targetLabel}</Text>

          <div className={classes.yearlyTrack}>
            <div
              className={classes.yearlyFill}
              style={{ height: `${normalizedProgress * 100}%` }}
            >
              <Text className={classes.yearlyFillValue}>{realizedLabel}</Text>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default YearlyProgress;
